import React from "react";
import { useTranslation } from "react-i18next";

import FacilitiesCard from "./components/FacilitiesCard";

import { facilitiesData } from "./utils/facilitesData";

import classes from "./index.module.css";

const Facilities = () => {
  const { t } = useTranslation();

  return (
    <div id="facilities" className={classes["wrapper"]}>
      <h3 className={classes["title"]}>{t("Facilities")}</h3>
      <div className={classes["facilities-wrapper"]}>
        {facilitiesData.map((facility) => {
          return <FacilitiesCard facility={facility} />;
        })}
      </div>
    </div>
  );
};

export default Facilities;
